import Invite from './invite';
import CashApp from './cashapp';
import Facebook from './facebook';
import Welcome from './welcome';
import Deposit from './deposit';

export default {
    Invite,
    CashApp,
    Facebook,
    Welcome,
    Deposit
}